<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable" v-if="roleid == '2'">
          <a class="navbar-link">
            <span>ຂຶ້ນແຜນ ແລະ ຕິດຕາມການຜະລິດ</span>
          </a>

          <div class="navbar-dropdown">
            <!-- <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/marketplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕາມຕະຫຼາດ</span>
            </router-link> -->
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/b2bcontractplanprogress"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕິດຕາມຄວາມຄືບໜ້າຂອງສັນຍາ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/b2bcontractplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕາມສັນຍາ</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable" v-if="roleid == '3'">
          <a class="navbar-link">
            <span>ຂຶ້ນແຜນ ແລະ ຕິດຕາມການຜະລິດ</span>
          </a>

          <div class="navbar-dropdown">
            <!-- <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/marketplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕາມຕະຫຼາດ (ສາຂາ)</span>
            </router-link> -->
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/b2bcontractplanbranch"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕາມສັນຍາ (ສາຂາ)</span>
            </router-link>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="roleid == '2' || roleid == '3'"
        >
          <a class="navbar-link">
            <span>ການຄຸ້ມຄອງຄຸນນະພາບ ແລະ ມາດຕະຖານ</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/oarecord"
              :exact="true"
              active-class="is-active"
            >
              <span>ປັດໃຈຂາເຂົ້າການຜະລິດ (Report)</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/oaicsrecord"
              :exact="true"
              active-class="is-active"
            >
              <span>ການກວດກາມາດຕະຖານອິນຊີ (Form + Report)</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/oacerform"
              :exact="true"
              active-class="is-active"
            >
              <span
                >ການສະຫມັກຂໍການຢັ້ງຢືນ ມາດຕະຖານກະສິກໍາອິນຊີ (Report +
                Action)</span
              >
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/oatrainingcourse"
              :exact="true"
              active-class="is-active"
            >
              <span
                >ຫລັກສູດການຝຶກອົບຮົມມາດຕະຖານກະສິກໍາອິນຊີ (Form + Report)</span
              >
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/oamanual"
              :exact="true"
              active-class="is-active"
            >
              <span>ຄູ່ມືການຜະລິດຕາມມາດຕະຖານກະສິກໍາອິນຊີ (Form + Report)</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable" v-if="roleid == '3'">
          <a class="navbar-link">
            <span>ການແຈ້ງເຕືອນ</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/plantnoti"
              :exact="true"
              active-class="is-active"
            >
              <span>ກຳນົດການຜະລິດ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/harvestnoti"
              :exact="true"
              active-class="is-active"
            >
              <span>ກຳນົດການເກັບກ່ຽວ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/weathernoti"
              :exact="true"
              active-class="is-active"
            >
              <span>ສະພາບອາກາດ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/generalnoti"
              :exact="true"
              active-class="is-active"
            >
              <span>ແຈ້ງເຕືອນທົ່ວໄປ</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ແຜນປະຈຳປີ ແລະ ລາຍງານ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/dppplan"
              :exact="true"
              active-class="is-active"
            >
              <span>ແຜນປະຈຳປີ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/oapp/dppreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານທຽບກັບແຜນປະຈຳປີ</span>
            </router-link>
            
          </div>
        </div>
        <!-- <div class="navbar-item has-dropdown is-hoverable" v-if="productionbycontract">
          
          <a class="navbar-link">
            <span>ຕິດຕາມການຜະລິດ</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/productionbymarket"
              :exact="true"
              active-class="is-active"
            >
              <span>ຜະລິດຕາມຕະຫຼາດ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/productionbycontract"
              :exact="true"
              active-class="is-active"
            >
              <span>ຜະລິດຕາມສັນຍາ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/productionoffarmer"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕິດຕາມການຜະລິດຊາວກະສິກອນ</span>
            </router-link>
          </div>
        </div> -->
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຕັ້ງຄ່າຕ່າງໆ</span>
          </a>
          <div class="navbar-dropdown" v-if="roleid == '2'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/setting/user"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຜູ້ໃຊ້ DPP ສາຂາ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/setting/branch"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສາຂາ</span>
            </router-link>

            <!-- <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/setting/farmer"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຊາວກະສິກອນ</span>
            </router-link> -->
          </div>
          <div class="navbar-dropdown" v-if="roleid == '3'">
            <!-- <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/branch"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສາຂາ--</span>
            </router-link> -->

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dpp/setting/farmer"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຊາວກະສິກອນ</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ {{ username }} - {{ rolename }}</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/profile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      roleid: null,
      rolename: null,
      username: null,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.rolename = this.user.ROLENAME;
    this.username = this.user.USERNAME;
    console.log("ROLENAME: " + this.user.ROLENAME);
    console.log("USERNAME: " + this.user.USERNAME);
  },
  computed: {
    // user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
